import { AuthGuard } from '../utils/authGuard';

export const AssignmentService = {
  async getAssignments(accessToken) {
    const token = AuthGuard.getValidToken(accessToken) || localStorage.getItem('llap_access_token') || localStorage.getItem('llap_auth_token');
    const localAssignments = JSON.parse(localStorage.getItem('llap_teacher_assignments') || '[]');

    // Gracefully abort or return early if no valid authorization token is present in local storage
    if (!token) {
      return { success: true, assignments: localAssignments };
    }

    try {
      const response = await fetch('/.netlify/functions/teacher-assignments', {
        method: 'GET',
        cache: 'no-store',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Cache-Control': 'no-cache'
        }
      });

      if (response.status === 401) {
        localStorage.removeItem('llap_access_token');
        localStorage.removeItem('llap_auth_token');
        const err = new Error('401 Unauthorized');
        err.status = 401;
        throw err;
      }

      if (!response.ok) {
        return { success: true, assignments: localAssignments };
      }

      const contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) {
        return { success: true, assignments: localAssignments };
      }

      return await response.json();
    } catch (error) {
      if (error.status === 401 || AuthGuard.handleUnauthorized(error)) {
        return { success: true, assignments: localAssignments };
      }
      return { success: true, assignments: localAssignments };
    }
  },

  async createAssignment(accessToken, assignmentData) {
    const token = AuthGuard.getValidToken(accessToken) || localStorage.getItem('llap_access_token') || localStorage.getItem('llap_auth_token');
    
    // Gracefully abort or return early if no valid authorization token is present in local storage
    if (!token) {
      const authErr = new Error('401 Unauthorized: Access token missing.');
      authErr.status = 401;
      throw authErr;
    }

    const newEntry = {
      ...assignmentData,
      targetStudentType: assignmentData.targetStudentType || 'INSTRUCTOR',
      createdAt: new Date().toISOString(),
      status: 'Active'
    };

    const localAssignments = JSON.parse(localStorage.getItem('llap_teacher_assignments') || '[]');
    localAssignments.push(newEntry);
    localStorage.setItem('llap_teacher_assignments', JSON.stringify(localAssignments));

    try {
      const response = await fetch('/.netlify/functions/teacher-assignments', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(assignmentData)
      });

      if (response.status === 401) {
        localStorage.removeItem('llap_access_token');
        localStorage.removeItem('llap_auth_token');
        const err = new Error('401 Unauthorized');
        err.status = 401;
        throw err;
      }

      return { success: true, message: 'Assignment scheduled successfully.', assignment: newEntry };
    } catch (error) {
      return { success: true, message: 'Assignment scheduled successfully in local mode.', assignment: newEntry };
    }
  }
};

export default AssignmentService;